const LOCAL_API_URL = "https://localhost:44310/api/";

export default {
  // Add common config values here
  // Mirrored from FileUploadValidator.MaxFileSizeBytes on the API. Update
  // both together if the limit changes.
  MAX_ATTACHMENT_SIZE: 10 * 1024 * 1024, // 10 MB
  ALLOWED_ATTACHMENT_EXTENSIONS: [".pdf", ".jpg", ".jpeg", ".png"],
  API_URL: process.env.REACT_APP_API_URL || LOCAL_API_URL,
};
